import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  PrepareEthDepositMutation,
  PrepareEthDepositMutationVariables,
} from './__generated__/usePrepareEthDeposit.graphql.ts';

const PREPARE_ETH_DEPOSIT_MUTATION = gql`
  mutation PrepareEthDepositMutation($input: prepareEthDepositInput!) {
    prepareEthDeposit(input: $input) {
      ethDeposit {
        starkKey
        vaultId
        assetType
        weiAmount
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  PrepareEthDepositMutation,
  PrepareEthDepositMutationVariables
>;

export const usePrepareMutation = () => {
  const [mutate] = useMutation(PREPARE_ETH_DEPOSIT_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return useCallback(
    async (weiAmount: bigint) => {
      const { data } = await mutate({ variables: { input: { weiAmount } } });

      return data?.prepareEthDeposit?.ethDeposit;
    },
    [mutate]
  );
};
